import { render, staticRenderFns } from "./TournamentHistory.vue?vue&type=template&id=74475243&scoped=true&"
import script from "./TournamentHistory.vue?vue&type=script&lang=js&"
export * from "./TournamentHistory.vue?vue&type=script&lang=js&"
import style0 from "./TournamentHistory.vue?vue&type=style&index=0&id=74475243&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74475243",
  null
  
)

export default component.exports